module.exports = __webpack_public_path__ + "assets/img/9b819dd618c680b24d6a941cb4c04171.svg";